import { useEffect } from 'react';

let flowgramStylesLoaded = false;
let flowgramStylesPromise: Promise<void> | null = null;

/**
 * 按需加载 flowgram 编辑器全局样式（全站只注入一次）。
 * @returns {Promise<void>}
 */
export function loadFlowgramEditorStyles(): Promise<void> {
  if (flowgramStylesLoaded) {
    return Promise.resolve();
  }
  if (!flowgramStylesPromise) {
    flowgramStylesPromise = import('@flowgram.ai/free-layout-editor/index.css').then(() => {
      flowgramStylesLoaded = true;
    });
  }
  return flowgramStylesPromise;
}

/**
 * 在画布页挂载时注入 flowgram 样式。与静态 import 画布组件搭配，避免 next/dynamic 阻断 ref。
 */
export function useFlowgramEditorStyles() {
  useEffect(() => {
    void loadFlowgramEditorStyles();
  }, []);
}

/**
 * 在拉取画布模块前先加载 flowgram 编辑器全局样式，避免在 _app 全站注入。
 * 适用于 next/dynamic 且无需 ref 的页面。
 * @template T
 * @param {() => Promise<{ default: T }>} moduleLoader 画布页面 default 导出
 * @returns {Promise<{ default: T }>}
 */
export function withFlowgramEditorStyles<T>(
  moduleLoader: () => Promise<{ default: T }>,
) {
  return loadFlowgramEditorStyles().then(() => moduleLoader());
}
